import React from 'react';
import { RegistrationCompletionContainer } from '../../containers';

const RegistrationCompletionPage = () => <RegistrationCompletionContainer />;

export default RegistrationCompletionPage;
